import { ReactNode } from 'react';

import './Columns.scss';

interface ColumnProps {
  /** Column heading (e.g. "Match", "Handle"). */
  readonly heading: ReactNode;
  /** Muted one-line description under the heading. */
  readonly subtitle?: ReactNode;
  readonly children: ReactNode;
}

/** A titled column within `Columns`: a header band (accent dot + heading + optional subtitle) over its content. */
const Column = ({ heading, subtitle, children }: ColumnProps) => (
  <div className="columns__column">
    <div className="columns__header">
      <div className="columns__title">
        <span className="columns__dot" aria-hidden="true" />
        <span className="columns__heading">{heading}</span>
      </div>
      {subtitle !== undefined && <span className="columns__subtitle">{subtitle}</span>}
    </div>
    <div className="columns__body">{children}</div>
  </div>
);

interface ColumnsProps {
  readonly children: ReactNode;
}

/**
 * A responsive multi-column layout for side-by-side titled groups (e.g. a matcher's Match | Handle split). Columns sit
 * side-by-side when there's room and stack when narrow. Generic — owns its styling; compose with `Columns.Column`.
 */
export const Columns = Object.assign(({ children }: ColumnsProps) => <div className="columns">{children}</div>, { Column });
